import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { clearCustomer, clearCustomerDataOld, i18n, navigate, openCallMeModal, setExamDraft, setSoId, setSoIdWeb, useAppDispatch } from "src/common";
import { Button, Card, Flex, RequestAgentCardV2, Text } from 'src/components';
import { AppRoutesAdditional } from "src/pages/app";
import { colors } from "src/theme";

const NoOfferButton = styled(Button)({
  width: '100%',
});

export const NoOfferPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSoIdWeb(null));
    dispatch(setSoId(null));
    dispatch(clearCustomer());
    dispatch(clearCustomerDataOld());
    dispatch(setExamDraft(null));
  }, []);

  return (
    <Card radius={12} padding={20}>
      <Flex vertical gap={32} justify="center" align="center"> 
        <Text type="base" color={colors.text2}>{i18n.t('pages.noOffer.text')}</Text>
        <NoOfferButton text={i18n.t('pages.noOffer.noOffer')} onClick={() => { navigate(AppRoutesAdditional.CUSTOMER_ONLY_DATE.fullPath) }} />
        <RequestAgentCardV2 onButtonClick={() => dispatch(openCallMeModal())} />
      </Flex>
    </Card>
  );
};
